<template>
  <v-menu offset-y left max-height="400" :close-on-content-click="false" attach>
    <v-btn flat icon slot="activator">
      <v-tooltip bottom open-delay="50" close-delay="50">
        <v-badge overlap color="red" slot="activator">
          <span slot="badge" v-if="unreadCount">{{ unreadCount }}</span>
          <v-icon color="white">notifications</v-icon>
        </v-badge>
        <span>Notificaciones</span>
      </v-tooltip>
    </v-btn>
    <v-list two-line>
      <template v-for="notification in notifications">
        <NotificationElement :key="'critical' + notification.id" :item="notification" @decrease="decreaseCounter()"
                             v-if="isCritical(notification)" :is-critical="isCritical(notification)"></NotificationElement>
      </template>
      <template v-for="notification in notifications">
        <NotificationElement :key="'normal' + notification.id" :item="notification" @decrease="decreaseCounter()"
                             v-if="!isCritical(notification)" :is-critical="isCritical(notification)"></NotificationElement>
      </template>
      <div>
        <v-list-tile ripple @click="goToNotifications">
          <v-list-tile-content>
            <v-list-tile-title class="text-xs-center"><span class="light-blue--text">Ver todas las notificaciones</span>
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </div>
      <div>
        <v-list-tile ripple @click="markAllAsRead">
          <v-list-tile-content>
            <v-list-tile-title class="text-xs-center"><span class="light-blue--text">Marcar todas como leídas</span>
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </div>
    </v-list>
  </v-menu>
</template>

<script>
import NotificationElement from './NotificationElement'

export default {
  components: {
    NotificationElement
  },

  data () {
    return {
      unreadCount: 0
    }
  },

  computed: {
    notifications () {
      return this.$store.state.notifications
    }
  },

  methods: {
    goToNotifications () {
      this.$router.push({ name: 'notificaciones' })
    },
    markAllAsRead () {
      this.axios
        .put(`notification/read/all`)
        .then(() => {
          this.unreadCount = 0
          this.$store.dispatch('fetchNotifications')
        })
        .catch(error => { this.$store.commit('setErrorMsg', error) })
    },
    decreaseCounter () {
      this.unreadCount--
    },
    isCritical (notification) {
      return notification.notification.urgency === 'Alta'
    }
  },

  mounted () {
    this.$store.dispatch('fetchNotifications')
  },

  watch: {
    '$store.state.notifications' () {
      this.unreadCount = (this.notifications.length) ? this.notifications[0].unreadCount : 0
    }
  }
}
</script>
